import { Injectable } from '@angular/core';
import { DataService } from './data.service';
import { Observable } from 'rxjs';
import { EnvironmentService } from 'projects/shared/services/environment.service';
import * as pdfjsLib from 'pdfjs-dist';

@Injectable()
export class FileService {

  docApiBaseUrl: string;

  constructor(private readonly _dataService: DataService,
    private readonly _environmentService: EnvironmentService
  ) {
    this.docApiBaseUrl = _environmentService.apiInfo.docApiBaseUrl;
    // Configure the worker source
    pdfjsLib.GlobalWorkerOptions.workerSrc = window.location.origin + '/assets/pdf.worker.min.mjs';
  }

  viewFile = (fileGuid: string): Observable<BlobPart> => {
    return this._dataService.downloadFile(
      `${this.docApiBaseUrl}/api/portal/view-file/${fileGuid}`,false
    );
  };

  downloadFile = (fileGuid: string): Observable<BlobPart> => {
    return this._dataService.downloadFile(
      `${this.docApiBaseUrl}/api/portal/download-file/${fileGuid}`,false
    );
  };

  async isPdfPasswordProtected(file: File): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      if (!file) {
        reject(new Error('No file provided'));
        return;
      }

      const fileReader = new FileReader();

      fileReader.onload = () => {
        try {
          const arrayBuffer = fileReader.result as ArrayBuffer;
          const pdfData = new Uint8Array(arrayBuffer);

          // Use PDF.js for detection - most reliable approach
          try {
            const loadingTask = pdfjsLib.getDocument({
              data: pdfData,
              password: '',
            });

            loadingTask.promise.then(
              (pdf) => {
                // Successfully loaded without password
                // Double-check: some PDFs might load but still be encrypted
                pdf.getPermissions().then(
                  (permissions) => {
                    // If permissions are restricted, it might be password-protected
                    // but opened with the owner password
                    resolve(false);
                  },
                  () => resolve(false) // Can't get permissions, assume not password protected
                );
              },
              (error) => {
                console.log('PDF.js error:', error);
                // Check specifically for password exceptions
                if (error && (
                  error.name === 'PasswordException' ||
                  error.code === 1 || // PDFJS PasswordResponses.NEED_PASSWORD
                  (error.message && (
                    error.message.includes('password') ||
                    error.message.includes('Password') ||
                    error.message.includes('encrypted')
                  ))
                )) {
                  resolve(true); // Password required
                } else {
                  // Some other error, assume not password protected
                  console.error('PDF parsing error:', error);
                  resolve(false);
                }
              }
            );
          } catch (pdfJsError) {
            console.error('PDF.js error:', pdfJsError);
            // If PDF.js fails completely, assume not password protected
            resolve(false);
          }
        } catch (error) {
          console.error('Error processing PDF:', error);
          reject(error);
        }
      };

      fileReader.onerror = (error) => {
        console.error('Error reading file:', error);
        reject(error);
      };

      fileReader.readAsArrayBuffer(file);
    });
  }
}
